import * as yup from 'yup';
import { FamilyMember } from '../../../../@posturinn/client-react';

export interface IChangeAddress {
	streetNumber: string;
	appartmentNumber: string;
	zip: {
		label: string;
		value: string;
	};
	additionalInformation: string;
	familyMembers: FamilyMember[];
}

export const changeAddressInitialValues: IChangeAddress = {
	streetNumber: '',
	appartmentNumber: '',
	zip: {
		label: '',
		value: '',
	},
	additionalInformation: '',
	familyMembers: [],
};

export const changeAddressSchema = yup.object().shape({
	street: yup.string().required('street-required'),
	streetNumber: yup
		.string()
		.required('streetNumber-required')
		.matches(/^[0-9]+[a-zA-Z]*$/, 'invalidValue'),
	appartmentNumber: yup.string().max(25, 'tooLong'),
	zip: yup.object().shape({
		value: yup.string().required(),
		label: yup.string().required(),
	}),
	additionalInformation: yup.string().max(100, 'tooLong'),
	familyMembers: yup.array().min(1, 'familyMembers-one-required'),
});
